import Vue from 'vue'
import Vuesax from 'vuesax'
import VueI18n from 'vue-i18n'
import VueResource from 'vue-resource'

import App from './App.vue'

import router from './router'
import messages from './locales'

import 'vuesax/dist/vuesax.css'
import 'material-icons/iconfont/material-icons.css'

Vue.config.productionTip = false

Vue.use(Vuesax, {
  theme:{
    colors:{
      primary:'#2c1d71',
      success:'#6552c4',
      danger:'#d62d13',
      warning:'#2f1937',
      dark:'#170c4f'
    }
  }
})
Vue.use(VueI18n)
Vue.use(VueResource)

const i18n = new VueI18n({
  locale: 'fr',
  messages
})

new Vue({
  i18n,
  router,
  render: h => h(App)
}).$mount('#app')
